<h4 class="sap-config-title bz-font-weight--semibold">{{'SAP_CP_CONFIGURATION.CONFIGURATION.CONFIGURATION_TITLE' |
  translate}} </h4>

<div class="center">
  <div class="">
    <form [formGroup]="configurationForm">
      <label class="bz-space bz-form-label" for="name"> {{'SAP_CP_CONFIGURATION.COMMON.NAME' | translate}} </label>
      <input class="bz-space--stack-m bz-input" required id="name" type="text"
        placeholder="{{'SAP_CP_CONFIGURATION.COMMON.NAME' | translate}}" formControlName="name">
      <label class="bz-space bz-form-label" for="dispatcherUrl"> {{'SAP_CP_CONFIGURATION.CONFIGURATION.DISPATCHER_HOST'
        | translate}} </label>
      <input class="bz-space--stack-m bz-input" required id="dispatcherUrl" type="text"
        placeholder="Eg: appname.cfapps.eu10.hana.ondemand.com" formControlName="dispatcherUrl">

      <div class="oauth">
        <div class="bz-space--inline-s bz-space--stack-xs">
          <bzg-radio-group class="oauth--radiobutton" required (change)="setAuthType($event)"
            formControlName="authenticationFlowType">
            <bzg-radio-button [value]="authenticationFlow.codeGrant">
              <span class="lbl-biz">{{'SAP_CP_CONFIGURATION.CONFIGURATION.CODEGRANT'|translate}}</span>
            </bzg-radio-button>
            <bzg-radio-button [value]="authenticationFlow.clientCredentials">
              <span
                class="lbl-biz">{{'SAP_CP_CONFIGURATION.CONFIGURATION.CLIENTCREDENCTIALS'|translate}}</span></bzg-radio-button>
          </bzg-radio-group>
        </div>
        <label class="bz-space bz-form-label" for="xsuaaUrl"> {{'SAP_CP_CONFIGURATION.CONFIGURATION.XSUAA_URL' |
          translate}} </label>
        <input class="bz-space--stack-s bz-input" required (change)="setXsuaaUrl($event)" id="xsuaaUrl" type="text"
          placeholder="Eg: https://51da1347.authentication.us10.hana.ondemand.com" formControlName="xsuaaUrl">

        <label class="bz-space bz-form-label" for="xsuaaClientId">
          {{'SAP_CP_CONFIGURATION.CONFIGURATION.XSUAA_CLIENT_ID' | translate}} </label>
        <input class="bz-space--stack-s bz-input" required (change)="setXsuaaClientId($event)" id="xsuaaClientId"
          type="password" placeholder="" formControlName="xsuaaClientId">

        <label class="bz-space bz-form-label" for="xsuaaClientSecret">
          {{'SAP_CP_CONFIGURATION.CONFIGURATION.XSUAA_CLIENT_SECRET' | translate}} </label>
        <input class="bz-space--stack-s bz-input" required (change)="setXsuaaClientSecret($event)"
          id="xsuaaClientSecret" type="password" placeholder="" formControlName="xsuaaClientSecret">
        <label class="bz-form-label bz-space--stack-m"
          for="destination">{{'SAP_CP_CONFIGURATION.CONFIGURATION.DESTINATION' | translate}} </label>
        <bzg-select required (valueChange)="setDestination($event)" class="bz-space--stack-m bz-sap-select"
          id="destination" [placeholder]="'SAP_CP_CONFIGURATION.CONFIGURATION.DESTINATION'| translate"
          formControlName="destination">
          <bzg-option *ngFor="let destination of destinations" [value]="destination.Name">{{destination.Name}}
          </bzg-option>
        </bzg-select>

        <div class="authorize-btn">
          <bzg-button-secondary (click)="getDestinations()" id="get_dest_button" [size]="'s'"
            [disabled]="disableBotonByNoAuth()" class="float_button--rightspace">
            {{'SAP_CP_CONFIGURATION.CONFIGURATION.GET_DESTINATIONS' |
            translate}}</bzg-button-secondary>
          <bzg-button-primary class="float_button" [size]="'s'" (click)="authorize()">
            {{'SAP_CP_CONFIGURATION.CONFIGURATION.AUTHORIZE' | translate}}</bzg-button-primary>
        </div>
      </div>
      <div>
        <button id="save_button" class="float_button bz-btn bz-btn" (click)="saveConfiguration()"
          [disabled]="disableBotonByNoAuth() || configurationForm.status != 'VALID'">
          {{'SAP_CP_CONFIGURATION.COMMON.SAVE' | translate}}</button>
        <button id="cancel_button" (click)="unSelectAction()"
          class="bz-space--inline-s bz-btn bz-btn bz-btn--secondary"> {{'SAP_CP_CONFIGURATION.COMMON.CANCEL' |
          translate}}</button>
      </div>
    </form>
  </div>

  <!--Connector Actions-->
  <div class="sap-cp-actions" *ngIf="sapConfiguration.actionList && getActions().length > 0">
    <h4 class="bz-font-weight--semibold">{{'SAP_CP_CONFIGURATION.CONFIGURATION.ACTIONS_TITLE' | translate}} </h4>
    <div class="sap-cp-actions_wrapper">
      <div class="sap-cp-actions_container bz-shadow--xs" *ngFor="let action of getActions()" [bzgTooltip]="action">
        {{action}}</div>
    </div>
  </div>
</div>
<div *ngIf="isLoading" class="sap-loading">
  <div class="sap-loading--icon">
    <bzg-loading [size]="'xl'"></bzg-loading>
  </div>
</div>

<biz-auth-code-grant #authcodegrant (onOauthData)="onOauthData($event)"></biz-auth-code-grant>